import { render, staticRenderFns } from "./record-search.vue?vue&type=template&id=577d8e88&scoped=true&"
import script from "./record-search.vue?vue&type=script&lang=js&"
export * from "./record-search.vue?vue&type=script&lang=js&"
import style0 from "./record-search.vue?vue&type=style&index=0&id=577d8e88&lang=less&scoped=true&"
import style1 from "./record-search.vue?vue&type=style&index=1&id=577d8e88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577d8e88",
  null
  
)

export default component.exports